<div class="regroup-page">
  <div class="page-inner">

    <!-- EN-TÊTE compact -->
    <div class="page-header">
      <span class="page-header__eyebrow">Gestion des activités</span>
      <span class="eyebrow-sep">/</span>
      <span class="page-header__title">Ajouter un regroupement d'activités</span>
    </div>

    <div class="regroup-card">
      <form
        [formGroup]="entityForm"
        (ngSubmit)="onSubmitActivity()"
        class="regroup-form"
      >

        <!-- ── Panel : sélection des activités ── -->
        <div class="panel">
          <div class="panel-header">
            <h4 class="panel-title">Activités associées</h4>
            <app-ui-button
              (click)="addActivity()"
              label="Ajouter une activité"
              iconLeft="add_circle_outline"
            ></app-ui-button>
          </div>

          <div class="structures-list" formArrayName="activitesSelectionnees">
            @for (control of activitesFormArray.controls; track $index) {
              <div class="structures-row">
                <div class="structures-row__select">
                  <app-select
                    [formControlName]="$index"
                    [options]="getAvailableActivities($index)"
                  />
                </div>
                <button
                  type="button"
                  class="btn-danger-icon"
                  [disabled]="activitesFormArray.length <= 1"
                  (click)="removeActivity($index)"
                  aria-label="Supprimer cette activité"
                >
                  <span class="material-icons">delete</span>
                </button>
              </div>
            }
          </div>
        </div>

        <!-- ── Informations complémentaires (stepper, visible si ≥ 2 activités) ── -->
        @if (activitesFormArray.length > 1 && activeStepId) {
          <div formGroupName="complementaryInfo" class="complementary-block">

            <div class="complementary-header">
              <h4 class="complementary-title">Informations Complémentaires</h4>
            </div>

            <!-- Stepper onglet -->
            <div class="stepper-wrapper">
              <div class="stepper-progress-bar">
                <div
                  class="stepper-progress-fill"
                  [style.width.%]="getProgressPercent()"
                ></div>
              </div>

              <nav class="stepper-nav" aria-label="Étapes">
                @for (step of steps; track step.id; let i = $index; let last = $last) {
                  <a
                    [routerLink]="[]"
                    [queryParams]="{ step: step.id }"
                    class="step-item"
                    [class.active]="activeStepId === step.id"
                    [class.completed]="completedSteps.includes(step.id)"
                    [class.disabled]="!completedSteps.includes(step.id) && activeStepId !== step.id"
                    [class.pmp]="step.id === 'stepfour'"
                    [attr.aria-current]="activeStepId === step.id ? 'step' : null"
                  >
                    <div class="step-bubble">
                      <span class="step-bubble__num">{{ i + 1 }}</span>
                      @if (step.id === 'stepfour') {
                        <div class="step-pmp-badge"></div>
                      }
                    </div>
                    <span class="step-label">{{ step.label }}</span>
                  </a>

                  @if (!last) {
                    <div
                      class="step-connector"
                      [class.completed]="completedSteps.includes(step.id)"
                    ></div>
                  }
                }
              </nav>
            </div>

            <!-- Contenu de l'étape active -->
            <div class="step-content-area">
              @if (activeStepId === 'generales') {
                <app-steponeactivities
                  [generalesData]="activity.generales"
                  (generalesChanges)="updateActivity($event, 'generales')"
                  (typeActivityChanged)="handleTypeActivityChange($event)"
                />
              }
              @if (activeStepId === 'activites') {
                <app-steptwoactivities
                  [activitiesData]="activity.activites"
                  (activitiesChanges)="updateActivity($event, 'activites')"
                  (pmpModeSelected)="handlePmpModeChange($event)"
                />
              }
              @if (activeStepId === 'budgets') {
                <app-stepthreeactivities
                  [budgetsData]="activity.budgets"
                  (budgetsChanges)="updateActivity($event, 'budgets')"
                  (submitActivity)="onSubmitActivity()"
                />
              }
              @if (activeStepId === 'stepfour' && showPmpStep) {
                <app-stepfouractivities
                  [stepfourData]="activity.stepfour"
                  (stepfourChanges)="updateActivity($event, 'stepfour')"
                />
              }
              @if (activeStepId === 'recap') {
                <app-recapactivities
                  [activityData]="activity"
                  (submitFinalActivity)="handleFinalSubmit()"
                />
              }
            </div>

          </div>
        }

      </form>
    </div>

  </div>
</div>